export default "__VITE_ASSET__B2DfN1$Q__"